// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { ExpandDoubleVector } from '../DoubleMatrix';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { Color } from '../../../Graphics';
export class VO extends IndicatorScriptBase {
    constructor() {
        super();
        this.Comments = 'Volume Oscillator';
        this.Company = 'TraderEvolution';
        this.ProjectName = 'VO';
        this.ExpirationDate = 0;
        this.SetIndicatorLine('Volume Oscillator', Color.Green, 2, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.PeriodMASlow = 28;
        super.InputParameter(new InputParameterInteger('Slow period', 'Slow period', 0, 1, 9999));
        this.PeriodMAFast = 14;
        super.InputParameter(new InputParameterInteger('Fast period', 'Fast period', 0, 1, 9999));
        this.smaSlowSeries = new ExpandDoubleVector();
        this.smaFastSeries = new ExpandDoubleVector();
    }
    Init() {
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'VO';
    }
    getCustomName() {
        return 'VO (' + this.ProjectName + ')';
    }
    NextBar() {
        this.smaSlowSeries.Add(0.0);
        this.smaFastSeries.Add(0.0);
        super.NextBar();
    }
    OnQuote() {
        if (this.CurrentData.Count - 1 <= Math.max(this.PeriodMASlow, this.PeriodMAFast)) {
            return;
        }
        this.setMASlow();
        this.setMAFast();
        super.SetValue(0, 0, this.getVO());
    }
    setMASlow() {
        this.smaSlowSeries[this.smaSlowSeries.Length - 1] = this.sma(this.PeriodMASlow);
    }
    setMAFast() {
        this.smaFastSeries[this.smaFastSeries.Length - 1] = this.sma(this.PeriodMAFast);
    }
    sma(period) {
        let volume = 0;
        for (let index = 0; index < period; index++) {
            volume += this.CurrentData.Volume(index);
        }
        return volume > 0 ? volume / period : 0;
    }
    getVO() {
        const result = (100 *
            (this.smaFastSeries[this.smaFastSeries.Length - 1] -
                this.smaSlowSeries[this.smaSlowSeries.Length - 1])) /
            this.smaSlowSeries[this.smaSlowSeries.Length - 1];
        return result;
    }
}
